const StdHeaderCell = (props) => {
    return <th className="py-3 px-4 text-left">{props.children}</th>;
};

export default StdHeaderCell;
